import { ShowProps, Tab, TabbedShowLayout } from "react-admin";
import SanitizedGrid from "../../components/SanitizedGrid";
import { Grid } from "@material-ui/core";
import Summary from "./Summary";
import ShowWrapper from "../../components/ShowWrapper";

const NotificationShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    {
      title: "Notifications",
      link: `/notifications`,
    },
    {
      title: id,
      link: "",
    },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        customNameWithId="Notification"
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default NotificationShow;
